import { useQuery, useQueryClient, } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { API_INBOXES_PATH } from 'src/services/api/inboxes/constants';
import {type IInbox} from 'src/services/api/inboxes/types';

type IInboxResponse = {
    inboxes: IInbox[]
}

export const useInboxes = () => {
    const queryClient = useQueryClient();

    return useQuery([queryKeys.inboxes], async () => {
        const res = await apiClient(API_INBOXES_PATH).json<IInboxResponse>();

        return res.inboxes;
    }, {
        keepPreviousData: true,
        onSuccess: (views) => {
            for (const view of views) {
                queryClient.setQueryData([queryKeys.inboxes, view.id], view);
            }
        }
    });
};
